// CurrentConversationGate.tsx
import { useEffect } from 'react'

import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useCurrentConversationStore } from '@/store/useCurrentConversationStore'

/**
 * CurrentConversationGate – a gate that redirects to the home page if the current conversation is not set.
 * (It could have been deleted)
 * @returns {JSX.Element}  null
 */
const CurrentConversationGate = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const currentId = useCurrentConversationStore(state => state.id)
  const { conversationId: rawUrlId } = useParams()
  const urlId = rawUrlId ? Number(rawUrlId) : undefined
  const atHome = location.pathname === '/chat'

  useEffect(() => {
    if (!atHome && currentId === null && urlId === undefined) {
      console.error('[CurrentConversationGate] Navigating to home')
      navigate('/chat', { replace: true })
      return
    }
  }, [currentId, navigate, urlId, location.state, atHome])

  return null
}

export default CurrentConversationGate
